(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components';
var StyledTh = styled('th').withConfig({
  displayName: "Th__StyledTh",
  componentId: "sc-1qkdcdf-0"
})([""]);
var _default = StyledTh;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledTh, "StyledTh", "/home/vsts/work/1/s/src/components/tables/Th.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/tables/Th.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();